module.exports = __webpack_public_path__ + "img/jo.62f88d05.svg";